export class ApiError extends Error { constructor(message: string, public status: number) { super(message); } }

export async function api<T>(url: string, options: RequestInit = {}): Promise<T> {
  let response: Response;
  try {
    response = await fetch(url, {
      credentials: "include",
      ...options,
      headers: { ...(options.body ? { "Content-Type": "application/json" } : {}), ...(options.headers || {}) }
    });
  } catch {
    throw new ApiError("Não foi possível alcançar o servidor do LinguaHome. Verifique a conexão e se a aplicação está em execução.", 0);
  }
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) throw new ApiError(payload.message || "Erro ao comunicar com o servidor.", response.status);
  return payload as T;
}
